import {
  OrganizationFeatures,
  OrganizationFeature,
} from '@trello/product-features';

interface IsPaidManagedEnterpriseMemberArgs {
  confirmed?: boolean;
  idEnterprise?: string | null;
  organizations?: {
    idEnterprise?: string | null;
    products?: number[];
  }[];
}

/**
 * A user is considered a Paid Managed Enterprise Member if all of the
 * following are true:
 *
 * - The user has a confirmed email
 * - The user has an `idEnterprise` (this designates them as managed)
 * - The user is on at least 1 team of that enterprise (filter out free SSO members)
 * - The Enterprise is a "real" enterprise (filter out BCPO)
 */
export const isPaidManagedEnterpriseMember = ({
  confirmed = false,
  idEnterprise = null,
  organizations = [],
}: IsPaidManagedEnterpriseMemberArgs): boolean => {
  if (!confirmed || !idEnterprise) {
    return false;
  }
  return Boolean(
    organizations.filter((team) => {
      return (
        team.idEnterprise === idEnterprise &&
        OrganizationFeatures.isFeatureEnabled(
          OrganizationFeature.EnterpriseUI,
          team.products && team.products[0],
        )
      );
    }).length > 0,
  );
};
